<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Main Machinery Groups &nbsp;
          <save-button @click="save"></save-button>
          <small v-if="isSaving">Saving...</small>
          <!-- <add-button link="/values/create"></add-button> -->
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Main Machinery Groups</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Vessel Drop Down -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <my-select
              style="margin: 9px !important"
              disableFormControl="true"
              :selection.sync="form.vessel_id"
              :suggestions="vessls"
              @change="getData()"
              placeholder="Select vessl name"
            ></my-select>
          </div>
        </div>
      </div>
    </div>
    <!-- /Vessel Drop Down -->
    <!-- <div class="alert alert-success" role="alert" v-if="submitStatus == 'OK'">
      <h4 class="alert-heading">Well done!</h4>
      Items Saved Successfully
    </div> -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div id="buttons">
              <button
                v-if="form.vessel_id"
                class="btn btn-inverse-primary btn-sm"
                @click="create_parent_node()"
              >
                New Item
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-success btn-sm"
                @click="create_new_node(selectedNode)"
              >
                Sub Item
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-warning btn-sm"
                @click="edit_existing_node(selectedNode)"
              >
                Edit
              </button>
              &nbsp; &nbsp;
              <button
                v-if="selectedNode"
                class="btn btn-inverse-danger btn-sm"
                @click="Delete_Node(selectedNode)"
              >
                Delete
              </button>
            </div>
            <br />
            <v-treeview
              v-if="form.vessel_id"
              v-model="treeData"
              :treeTypes="treeTypes"
              @selected="selected"
              :openAll="openAll"
              :contextItems="contextItems"
              @contextSelected="contextSelected"
            ></v-treeview>
            <br />
          </div>
        </div>
      </div>
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Add New Parent -->
            <div v-if="editor_display == 1">
              <div class="col-md-3">
                <button
                  class="btn btn-inverse-primary btn-sm"
                  @click="addParent(name, code)"
                >
                  Save
                </button>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <label for="New Parent">Group Name</label>
                  <input
                    type="text"
                    ref="add_parent"
                    class="form-control"
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Name..."
                    v-model="name"
                  />
                  <!-- @keydown.enter="addParent(text)" -->
                </div>
                <div class="col-md-6">
                  <label for="New Parent">Group Code</label>
                  <input
                    type="text"
                    ref="add_parent"
                    class="form-control"
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Code..."
                    v-model="code"
                  />
                  <!-- @keydown.enter="addParent(text)" -->
                </div>
              </div>
            </div>
            <!--/ Add New Parent -->
            <!-- Adding Sub Items -->
            <div v-if="editor_display == 2">
              <div class="col-md-3">
                <button
                  class="btn btn-inverse-primary btn-sm"
                  @click="add_node(current_node, empty_node)"
                >
                  Save
                </button>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <label for="Sub Item">Sub Group Name</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Name..."
                    v-model="empty_node.name"
                  />
                  <!-- @keydown.enter="add_node(current_node, empty_node)" -->
                </div>
                <div class="col-md-6">
                  <label for="Sub Item">Sub Group Code</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    placeholder="Code..."
                    v-model="empty_node.code"
                  />
                  <!-- @keydown.enter="add_node(current_node, empty_node)" -->
                </div>
              </div>
            </div>
            <!--/ Adding Sub Items -->
            <!-- Edit Existing Items -->
            <div v-if="editor_display == 3">
              <div class="col-md-3">
                <button
                  class="btn btn-inverse-primary btn-sm"
                  @click="edited_node(current_node, name, code)"
                >
                  Update
                </button>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <label for="Edit Item">Edit Group Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Name..."
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    v-model="name"
                  />
                  <!-- @keydown.enter="edited_node(current_node)" -->
                </div>
                <div class="col-md-6">
                  <label for="Edit Item">Edit Group Code</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Code..."
                    :class="[
                      is_existing == true || is_blank == true
                        ? 'is-invalid'
                        : 'is-valid',
                    ]"
                    v-model="code"
                  />
                  <!-- @keydown.enter="edited_node(current_node)" -->
                </div>
              </div>
            </div>
            <!--/ Edit Existing Items -->
            <!-- Error Message -->
            <div class="alert alert-danger" v-show="is_existing" role="alert">
              <i data-feather="alert-circle"></i>
              <label for="Duplicate Entries"
                ><strong>Duplicated Entries Found</strong></label
              >
            </div>
            <div class="alert alert-danger" v-show="is_blank" role="alert">
              <i data-feather="alert-circle"></i>
              <label for="Blank Entries"
                ><strong>this field is required</strong></label
              >
            </div>

            <!--/ Error Message -->
            <!-- Success Message -->
            <div
              class="alert alert-success"
              role="alert"
              v-show="submitStatus == 'OK'"
            >
              <h4 class="alert-heading">Items Added to Tree Successfully</h4>
              Now Click the <i data-feather="save"></i>button on Top to save the
              latest Tree
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <!-- Table -->
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import VTreeview from "v-treeview";
// const ADD_PARENT = 1;
const ADD_CHILD = 2;
const EDIT_NODE = 3;
// Delete Node
const filterObject = (object, id) => {
  const newObj = [];
  object.map((element) => {
    if (parseInt(element.id) === parseInt(id)) return;
    if (element.items) element.items = filterObject(element.items, id);
    if (element.children) element.children = filterObject(element.children, id);
    newObj.push(element);
  });
  return newObj;
};
export default {
  name: "Values",
  data() {
    return {
      openAll: false,
      form: {
        value_id: "",
        company_id: "",
        vessel_id: "",
      },
      vessls: [],
      treeTypes: [
        {
          type: "#",
          valid_children: ["PARENT"],
        },
        {
          type: "PARENT",
          icon: "fa fa-crosshairs",
          valid_children: ["CHILD"],
        },
        {
          type: "CHILD",
          icon: "fa fa-crosshairs",
          valid_children: ["CHILD"],
        },
      ],
      // Tree data For treeview
      treeData: [],
      //Json For Backend
      json_data: [],
      json_data_string: [],
      // RAW JSON for Validation
      RawData: [],

      value_list: [],
      valueLists: [],
      contextItems: [],
      selectedNode: null,
      current_node: null,

      isLoading: false,
      isSaving: false,

      editor_display: false,
      is_existing: false,
      is_blank: false,
      name: "",
      code: "",
      submitStatus: "PENDING",
    };
  },
  mounted() {
    // this.getData();
    this.getMasters();
  },
  components: {
    VTreeview,
  },
  methods: {
    // Open Parent Node
    create_parent_node() {
      // For Display Add Parent Item
      this.editor_display = true;
      // For Empty Current Node
      this.current_node = null;
      // For Empty Name Field
      this.name = "";
      // For Empty Code Field
      this.code = "";
    },
    async getMasters() {
      let masters = await axios.get("value_lists/masters");
      masters = masters.data;
      masters.values.forEach((value) => {
        if (value.name == "VESSEL") {
          value.value_lists.forEach((valueList) => {
            this.vessel_id = valueList.id;
            this.vessls.push({
              id: valueList.id,
              name: valueList.name + " | " + valueList.code,
            });
          });
        }
      });
    },
    async get_validate() {
      this.json_data = this.RawData;
      this.json_data_string = JSON.stringify(this.json_data);
      console.log(this.json_data_string);
      let is_existing = await axios.get(
        `value_lists/check_unique_json_code?json_data=${this.json_data_string}`
      );
      this.is_existing = is_existing.data.Found;
      return this.is_existing;
    },
    Delete_Node(node) {
      // Remove Child
      this.RawData = filterObject(this.RawData, node.model.id);
      // console.log(this.RawData);
      this.treeData = this.RawData;
    },
    getTypeRule(type) {
      var typeRule = this.treeTypes.filter((t) => t.type == type)[0];
      return typeRule;
    },
    async addParent(name, code) {
      // Validation
      this.is_existing = false;
      if (name != "" && name != null && code != "" && code != null) {
        this.is_blank = false;

        // creating Random Ids
        let checked_id = Math.round(Math.random() * 100000);
        // creating a New Parent Node
        let node = {
          id: checked_id,
          text: code + " - " + name,
          name: name,
          code: code,
          type: "PARENT",
          children: [],
          items: [],
        };
        // Pushing the Newly Created Node in the rawData For Validation
        this.RawData.push(node);
        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Pushing the Newly Created Node in the Main Tree Data
          this.treeData.push(node);
          if (this.valueLists.length > 0) {
            let selectedRAWNode = this.searchNode(node.id, this.RawData);
            // Remove Duplicate Node if Exist from RawData
            this.RawData.splice(this.RawData.indexOf(selectedRAWNode), 1);
            this.treeData = this.RawData;
          }
          // After Pushing Empty the text Field
          this.name = null;
          this.code = null;
          // After Everything Hide the Text field
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          this.RawData.splice(this.RawData.indexOf(node), 1);
        }
      } else {
        this.is_blank = true;
      }
    },
    // Opens New Form For Adding New Child
    create_new_node(current_node) {
      this.editor_display = ADD_CHILD;
      this.selectedNode = current_node;
      // Make currently selected Node Blank
      this.current_node = null;
      // Redefining
      this.current_node = current_node.model;
      // creating Random Ids
      let checked_id = Math.round(Math.random() * 100000);
      // Create an Empty Node
      this.empty_node = {
        id: checked_id,
        text: "",
        name: "",
        code: "",
        type: "CHILD",
        children: [],
        items: [],
      };
    },
    // Add a new Child
    async add_node(current_node, child_node) {
      // Validation
      this.is_existing = false;
      // Make currently selected Node Blank
      this.current_node = null;
      // Redefining
      this.current_node = current_node;
      // If TEXT is not Null
      if (
        Object.keys(child_node["name"]).length != 0 &&
        Object.keys(child_node["code"]).length != 0
      ) {
        this.is_blank = false;
        // Assigning Code & Name
        // child_node["name"] = child_node["text"];
        let display_name = child_node["code"] + " - " + child_node["name"];
        child_node["text"] = display_name;

        // Search the Exact Node in RawData
        let selectedRAWNode = this.searchNode(current_node.id, this.RawData);
        // Add node in RAW Data
        selectedRAWNode.items.push(child_node);

        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Push the Newly Created Node in Current Node
          this.current_node.children.push(child_node);
          // After Pushing Empty the empty Node Field
          this.child_node = {};
          // Make currently selected Node Blank
          this.current_node = null;
          // Hide Editor
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          selectedRAWNode.items.splice(
            selectedRAWNode.items.indexOf(child_node),
            1
          );
        }
      } else {
        this.is_blank = true;
      }
    },
    // Opens Edit Form
    edit_existing_node(node) {
      this.editor_display = EDIT_NODE;
      this.current_node = null;
      this.current_node = node.model;
      this.name = node.model.name;
      this.code = node.model.code;
    },
    // Save the Edited Entry
    async edited_node(node, name, code) {
      // Validation
      this.is_existing = false;
      // If TEXT is not Null
      if (name != "" && name != null && code != "" && code != null) {
        this.is_blank = false;
        // Make currently selected Node Blank
        this.current_node = null;
        // Search the Exact Node in RawData
        node["name"] = name;
        node["code"] = code;

        let selectedRAWNode = this.searchNode(node.id, this.RawData);
        let display_name = node["code"] + " - " + node["name"];
        node["text"] = display_name;
        selectedRAWNode = node;
        // Redefining
        this.current_node = node;
        // Validation Part
        await this.get_validate();
        if (this.is_existing == false) {
          // Make currently selected Node Blank
          this.current_node = null;
          // Hide Editor
          this.editor_display = false;
          // Show Success Message
          this.submitStatus = "OK";
          setTimeout(() => {
            // Hide Success Message in 3 Sec
            this.submitStatus = "PENDING";
          }, 3000);
        } else {
          // Remove Currently Added Node from RawData
          selectedRAWNode.splice(selectedRAWNode.indexOf(node), 1);
        }
      } else {
        this.is_blank = true;
      }
    },
    contextSelected(command) {
      switch (command) {
        case "Create CHILD":
          var node = {
            text: "New Sub Item",
            type: "CHILD",
            children: [],
            items: [],
          };
          this.selectedNode.addNode(node);
          this.selectedNode.open = true;
          break;
        case "Create Top-up":
          node = {
            text: "New Top-up",
            type: "Top-up",
            children: [],
          };
          this.selectedNode.addNode(node);
          break;
        case "Rename":
          this.selectedNode.editName();
          break;
        case "Remove":
          break;
      }
      this.selectedNode = null;
    },
    selected(node) {
      this.selectedNode = node;
    },
    searchNode(id, currentNode) {
      var result;

      for (const [key, value] of Object.entries(currentNode)) {
        if (key == "id" && value == id) return currentNode;
        if (value !== null && typeof value === typeof []) {
          result = this.searchNode(id, value);
          if (result) {
            return result;
          }
        }
      }
    },
    // ------------------------------------------------------------------------------------------------------------------------
    // Get Data
    async getData(page = 1) {
      this.valueLists = [];
      this.ExportValueLists = [];
      this.isLoading = true;
      let masters = await axios.get("value_lists/masters");
      masters = masters.data;
      masters.values.forEach((value) => {
        if (
          value.name == "Main Machinery Groups" &&
          value.category == "Planned Maintenance"
        ) {
          // let value_id = value.id;
          this.form.value_id = value.id;
        }
      });
      this.form.company_id = this.company.id;
      let valueLists = await axios.get(
        `/values/${this.form.value_id}/value_lists?vessel_id=${this.form.vessel_id}`
      );
      this.valueLists = valueLists.data.data;

      if (this.valueLists.length > 0) {
        this.value_list = this.valueLists[0];
        this.treeData = this.value_list.json_data;
        this.RawData = this.value_list.json_data;
      } else {
        this.value_list = [];
        this.treeData = [];
        this.RawData = [];
      }
      this.count = valueLists.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async save() {
      this.json_data = this.RawData;
      if (this.json_data.length > 0) {
        // console.log(this.json_data);
        this.isSaving = true;
        this.form.json_data = this.json_data;
        let response = "";
        if (Object.keys(this.value_list).length != 0) {
          // FOR UPDATE
          // console.log(this.form);
          response = await axios.patch(
            `/values/${this.form.value_id}/value_lists/${this.value_list.id}`,
            this.form
          );
        } else {
          // FOR ADD
          response = await axios.post(
            `/values/${this.form.value_id}/value_lists`,
            this.form
          );
        }
        this.value_list = response.data.data;
        // console.log(this.value_list);
        this.isSaving = false;
      }
    },
  },
};
</script>
